import { useMemo } from "react";

import { SWReactCountryIcons, SWReactIcons } from "@similarweb/icons";
import type { IconName } from "@similarweb/icons";

import { useFormattedDuration } from "app/pages/benchmark-tracker/hooks/useFormattedDuration";
import { countryTextByIdFilter } from "app/filters/ngFilters";
import { useWebSources } from "app/pages/benchmark-tracker/hooks/topFilters/useWebSources";
import { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";
import { BenchmarkMetricName } from "app/pages/benchmark-tracker/types/api.types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { StyledIconWrapper, StyledInfoItem, StyledInfoWrapper, StyledText } from "./styles";

type SubTitleSchema = {
    metricName: BenchmarkMetricName;
};

export const SubTitle = ({ metricName }: SubTitleSchema) => {
    const { country, duration, webSource, granularity } = proNavigator.getParams();
    const { availableWebSources } = useWebSources();
    const dateGranularity =
        metricName === BenchmarkMetricName.audienceReach ? BenchmarkGranularity.MONTHLY : granularity;
    const formattedDuration = useFormattedDuration(dateGranularity, duration);

    const webSourceInfo = useMemo(
        () => availableWebSources.find((source) => source.id === webSource),
        [availableWebSources, webSource],
    );

    return (
        <StyledInfoWrapper>
            <StyledInfoItem>
                <StyledIconWrapper>
                    <SWReactIcons iconName="daily-ranking" />
                </StyledIconWrapper>
                <StyledText>{formattedDuration}</StyledText>
            </StyledInfoItem>

            <StyledInfoItem>
                <StyledIconWrapper>
                    <SWReactCountryIcons countryCode={country} />
                </StyledIconWrapper>
                <StyledText>{countryTextByIdFilter()(country)}</StyledText>
            </StyledInfoItem>

            {webSourceInfo ? (
                <StyledInfoItem>
                    <StyledIconWrapper>
                        <SWReactIcons iconName={webSourceInfo.icon as IconName} />
                    </StyledIconWrapper>
                    <StyledText>{webSourceInfo.text}</StyledText>
                </StyledInfoItem>
            ) : null}
        </StyledInfoWrapper>
    );
};
